export default {
  auto: ['actions', 'mutations', 'getters'],
}
